// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"609":"b1796483","787":"33db6acd"}[chunkId] + ".chunk.js";
};